export default __webpack_public_path__ + "static/media/driver_rejected.54902339.svg";